import React, { Component } from 'react';
import { Icon, Button } from 'react-materialize';

import EventUtils from '../../utils/EventUtils';

import defaultThumbnail from '../../images/EmptyPicture.png';

class CartItem extends Component {  
  constructor(props){
    super(props);

    this._handleRemoveClick = this._handleRemoveClick.bind(this);
  }

  _handleRemoveClick(event){
    let removeBtnId = this._remove._btnEl.dataset.tooltipId;
    window.$(`#${removeBtnId}`).remove();
    EventUtils.raiseEvent('delete', { index: this.props.id }, this.props)
  }

  render() {
    const { thumbnail, title, subtitle } = this.props; 
    return (
        <div className="cart-item">
            <img src={ thumbnail ? thumbnail : defaultThumbnail } alt={ title } />
            <div className="text-container">
              <h2 className="title">{ title }</h2>
              <h3 className="subtitle">{ subtitle }</h3>
            </div>
            <div className="btn-container">
              <Button ref={element => this._remove = element} id="tooltipped" tooltip="Remove" onClick={ this._handleRemoveClick }>
                <Icon>highlight_off</Icon>
              </Button>
            </div>
        </div>
    );
  }
}

export default CartItem;